/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['span.queue[_ngcontent-%COMP%]{background:#f39c12;color:#fff;border-radius:12px 12px 12px 12px;padding:5px 5px 5px 5px;font-size:.9em}a.date[_ngcontent-%COMP%]{color:#d3d3d3;text-decoration:underline}i.resolve[_ngcontent-%COMP%]{cursor:pointer;color:#27ae60;font-size:20px;text-shadow:0 -1px 0 rgba(0,0,0,.5)}.ticket-container[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{padding-left:7px}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3RpY2tldHMvdGlja2V0L3RpY2tldC5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3RyYXZpcy9idWlsZC9pbnNwaXJlaGVwL3JlY29yZC1lZGl0b3Ivc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy90aWNrZXRzL3RpY2tldC90aWNrZXQuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/shared/components/tickets/ticket/ticket.component.scss.shim.ngstyle.ts